import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Typography,
    Box,
    CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { getMarkdown } from "../utils/api";
import Loader from "./Loader";

const ChangeLogPopup = ({ open, handleClose, version, publishDate, componentName }) => {
    const [markdown, setMarkdown] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const fetchMarkdown = async () => {
        if (!version || !componentName) return;
        try {
            setError("");
            setLoading(true);

            const data = await getMarkdown(componentName, version);
            setMarkdown(data);
        } catch (err) {
            console.error("Error fetching markdown:", err);
            setError("Error occurred while loading changelog.");
            setMarkdown(""); // Clear markdown
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (open) fetchMarkdown();
    }, [version, open]);

    useEffect(() => {
        if (!open) {
            setMarkdown("");
            setError("");
        }
    }, [open]);


    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md"
            PaperProps={{ sx: { borderRadius: 2, p: 1 } }}
        >
            <DialogTitle sx={{ fontWeight: 600, fontSize: "20px" }}>
                Latest Release Notes
                <IconButton onClick={handleClose} sx={{ position: "absolute", right: 8, top: 8 }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                <Box sx={{ mb: 2 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                        v{version}
                    </Typography>
                    <Typography variant="body2" sx={{ color: "text.secondary" }}>
                        Published on {publishDate}
                    </Typography>
                </Box>

                {loading ? (
                    <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
                        <Loader />
                    </Box>
                ) : error ? (
                    <Typography sx={{ color: "red", fontWeight: 600, textAlign: "center", py: 2 }}>
                        {error}
                    </Typography>
                ) : (
                    <Box
                        sx={{
                            typography: { sm: "body2", xs: "subtitle1" },
                            color: "#333",
                            lineHeight: 1.6,
                            "& p": { mb: 1.2 },
                            "& ul": { pl: 3, mb: 1.5 },
                            "& h3": { fontSize: "16px", fontWeight: 700, mt: 2, mb: 1 },
                        }}
                    >
                        <ReactMarkdown>{markdown}</ReactMarkdown>
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default ChangeLogPopup;
